import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { Body1, SectionLabel, StatusBadge } from '../blocks';
import SubregionCarriersSection from './SubregionCarriersSection';

// The subregion's carriers. Middle Mile is set per carrier in More details.
const CarriersSection = ({
    isNew,
    draft,
    carriersForLeg,
    allCarriers,
    hoveredCarrierId,
    regionZipsByCarrier,
    onCarrierHover,
}) => {
    // From the draft, so the badge clears before Save.
    const hasCarrier = !!draft.carriers.length;

    return (
        <Grid
            container
            direction="column"
            css={css`
                flex-wrap: nowrap;
                gap: 8px;
                padding: 12px 16px;
                border-top: 1px solid ${colors.greys.border};
            `}
        >
            <Grid
                container
                css={css`
                    align-items: center;
                    gap: 8px;
                `}
            >
                <SectionLabel>Carriers</SectionLabel>
                {hasCarrier ? null : <StatusBadge tone="danger">required — gates go-live</StatusBadge>}
            </Grid>
            <Body1
                css={css`
                    color: ${colors.greys[2]};
                `}
            >
                Set a primary carrier that orders get auto assigned to in this subregion
            </Body1>
            {isNew ? (
                <Body1
                    css={css`
                        color: ${colors.greys[2]};
                    `}
                >
                    Save this subregion to start adding carriers.
                </Body1>
            ) : (
                <SubregionCarriersSection
                    draft={draft}
                    carriersForLeg={carriersForLeg}
                    allCarriers={allCarriers}
                    hoveredCarrierId={hoveredCarrierId}
                    regionZipsByCarrier={regionZipsByCarrier}
                    onCarrierHover={onCarrierHover}
                />
            )}
        </Grid>
    );
};

export default CarriersSection;
